import type { v1 } from '@hc-frontend/services-lead-storage';
import { assoc, reduce } from 'ramda';

export function userAttributesMapper(userAttributes: v1.UserAttribute[]) {
  const userAttributesMap: Partial<{
    [key in v1.UserAttributeCatalogKey]: v1.UserAttributeCatalog[key];
  }> = {
    ...reduce(
      (acc, curr) => assoc(curr.name, curr.value, acc),
      {},
      userAttributes,
    ),
  };
  return userAttributesMap;
}
